import { Timestamp } from 'firebase/firestore';
import { ItemChoiceType } from './common';

/** 検索項目ごとの検索方式 */
export const searchMatchMode = {
  fuzzy: 'fuzzy',
  exact: 'exact',
} as const;

export type SearchMatchMode = (typeof searchMatchMode)[keyof typeof searchMatchMode];

/** 検索項目の入力タイプ */
export const searchFieldInputType = {
  freeText: 'freeText',
  text: 'text',
  select: 'select',
  dateRange: 'dateRange',
  date: 'date',
  number: 'number',
  boolean: 'boolean',
  /** 選択肢項目（ラジオボタン・プルダウン）: 設定済みの選択肢から複数選択して検索する（#3204）。
   *  固定項目のプルダウン（担当者・作成者など）を表す select とは区別する。 */
  choice: 'choice',
} as const;

export type SearchFieldInputType = (typeof searchFieldInputType)[keyof typeof searchFieldInputType];

/** 各検索項目の設定 */
export interface SearchFieldConfig {
  /** Firestoreフィールド名 */
  fieldName: string;
  /** 表示名 */
  label: string;
  /** 入力タイプ */
  inputType: SearchFieldInputType;
  /** 有効/無効 */
  enabled: boolean;
  /** 検索方式（text型・freeText型で使用） */
  matchMode: SearchMatchMode;
  /** OCR読取項目フラグ */
  isOcrItem?: boolean;
  /** 子項目の場合の親項目ID */
  parentId?: string;
  /** 日付型の出力フォーマット（date型のみ。OCR結果は item_list の outputFormat で文字列化されているため、検索値も同フォーマットで揃える） */
  outputFormat?: string;
  /** 選択肢リスト（choice型のみ。#3204）。
   *  Firestoreには保存せず、パターンの item_list から都度生成する（選択肢の編集に自動追従させるため） */
  choices?: ItemChoiceType[];
  /** 一覧表示列に表示するか */
  showInList?: boolean;
  /** 固定項目のうち、一覧表示のON/OFFをユーザーが切り替えられるか（作成者列など） */
  canToggleList?: boolean;
}

/** Firestore保存用の検索設定（snake_case） */
export interface SearchSettingsFieldType {
  field_name: string;
  label: string;
  input_type: string;
  enabled: boolean;
  match_mode: string;
  is_ocr_item: boolean;
  parent_id: string | null;
  show_in_list?: boolean;
}

/** Firestore保存用の検索カスタマイズ設定 */
export interface SearchSettingsType {
  fields: SearchSettingsFieldType[];
  updated_at?: Timestamp;
  updated_by?: string;
}
